export const COLOR_KEYS = ["red", "blue", "yellow", "green", "purple", "orange"] as const;
export type Color = (typeof COLOR_KEYS)[number];

export const COLOR_HEX: Record<Color, number> = {
  red: 0xef4444,
  blue: 0x3b82f6,
  yellow: 0xfacc15,
  green: 0x22c55e,
  purple: 0xa855f7,
  orange: 0xf97316,
};

export const COLOR_CSS: Record<Color, string> = {
  red: "#ef4444",
  blue: "#3b82f6",
  yellow: "#facc15",
  green: "#22c55e",
  purple: "#a855f7",
  orange: "#f97316",
};

export function colorHex(c: Color): number {
  return COLOR_HEX[c];
}
